import { COLORS } from '@/constants';
import { FormControl, InputLabel, MenuItem, Slider, TextField } from '@mui/material';
import styled from 'styled-components';

export const StyledFormControl = styled(FormControl)`
  padding: 0px 6px !important;
  width: 100%;
  box-sizing: border-box;
`;

export const LabelBox = styled(InputLabel)`
  display: flex !important;
  gap: 4px;
  align-items: start;
  padding-right: 10px;
  height: fit-content;
`;

export const StyledSlider = styled(Slider)`
  &.MuiSlider-root {
    color: ${COLORS['secondary/400']};
    height: 4px;
    width: 100%;
  }

  & .MuiSlider-thumb {
    width: 18px;
    height: 18px;
    background-color: ${COLORS['white']};
    border: 4px solid ${COLORS['secondary/400']};
    box-shadow: inherit;

    &:focus,
    &:hover,
    &.Mui-active,
    &.Mui-focusVisible {
      box-shadow: inherit;
    }
  }

  & .MuiSlider-track {
    border: none;
  }

  & .MuiSlider-valueLabel {
    padding: 0 6px;
    font-size: 12px;
    padding: 3px 8px;
    background-color: black;
  }
`;

export const StyledCountData = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: black;
  font-weight: 500;
`;

export const ValueWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  gap: 8px;
`;

export const Separator = styled.span`
  width: 100%;
  border-bottom: 1px solid ${COLORS['neutral/300']};
`;

export const StyledRangeInput = styled(TextField)`
  min-width: 40%;

  & .MuiOutlinedInput-root {
    height: 32px;

    & fieldset {
      border-color: ${COLORS['neutral/300']};
    }

    & input {
      height: 32px;
      padding: 0 8px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const HiddenMenuItem = styled(MenuItem)`
  display: none !important;
  min-height: 0;
  padding: 0;
  margin: 0;
  height: 0;
`;
